import { useAxios } from '../contexts/axiosContext';

export default function CandidateService() {
  const { authAxios } = useAxios();

  function buildCandidateFormData(params, files = []) {
    const formData = new FormData();

    formData.append(
      'params',
      new Blob([JSON.stringify(params)], { type: 'application/json' })
    );

    (files || []).forEach((f) => {
      if (f) formData.append('files', f);
    });

    return formData;
  }

  const paramsSerializer = (p) => {
    const usp = new URLSearchParams();

    Object.entries(p || {}).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') return;

      if (Array.isArray(v)) {
        v.forEach((x) => {
          if (x === undefined || x === null || x === '') return;
          usp.append(k, x);
        });
      } else {
        usp.append(k, v);
      }
    });

    return usp.toString();
  };

  function list({ page = 0, pageSize = 15, filters = {}, signal } = {}) {
    return new Promise((resolve, reject) => {
      const params = {
        page,
        pageSize,
        orderBy: 'LAST_MODIFIED_DATE_DESC',
        ...filters,
      };

      authAxios.get('/candidates', { params, paramsSerializer, signal })
        .then((resp) => resolve(resp.data.data))
        .catch((err) => reject(err));
    });
  }

  function get(id, { signal } = {}) {
    return new Promise((resolve, reject) => {
      authAxios.get(`/candidates/${id}`, { signal })
        .then((resp) => resolve(resp.data.data))
        .catch((err) => reject(err));
    });
  }

  function create(params, files = []) {
    return new Promise((resolve, reject) => {
      const formData = buildCandidateFormData(params, files);

      authAxios.post('/candidates', formData)
        .then((resp) => resolve(resp.data.data))
        .catch((err) => reject(err));
    });
  }

  function update(id, params, files = []) {
    return new Promise((resolve, reject) => {
      const formData = buildCandidateFormData(params, files);

      authAxios.patch(`/candidates/${id}`, formData)
        .then((resp) => resolve(resp.data.data))
        .catch((err) => reject(err));
    });
  }

  function remove(id) {
    return new Promise((resolve, reject) => {
      authAxios.delete(`/candidates/${id}`)
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  }

  function listFilterCities({ signal } = {}) {
    return new Promise((resolve, reject) => {
      authAxios.get('/candidates/filters/cities', { signal })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  }

  return { list, get, create, update, remove, listFilterCities };
}